import Vue from 'vue'
// import VueResource from 'vue-resource'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueProgressBar from 'vue-progressbar'
// import Notify from 'vue-notification'

// Vue.use(VueResource)
Vue.use(VueAxios, axios)
// Vue.use(Notify)
Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px'
})

export default {
  get: function (url, config, success, error) {
    Vue.prototype.$Progress.start()
    Vue.axios.get(url, config).then(function (e) {
      Vue.prototype.$Progress.finish()
      if (typeof success === 'function') {
        success(e.data)
      }
    }, function (e) {
      Vue.prototype.$Progress.fail()
      if (e) {
        if (e.name === undefined) {
          Vue.prototype.$Notify.error('Error', 'Ada kesalahan saat komunikasi ke web server...')
        } else {
          Vue.prototype.$Notify.error(e.name, e.message)
        }
      }
      if (typeof error === 'function') {
        error(e)
      }
    })
  },
  delete: function (url, config, success, error) {
    Vue.prototype.$Progress.start()
    Vue.axios.delete(url, config).then(function (e) {
      Vue.prototype.$Progress.finish()
      if (typeof success === 'function') {
        success(e.data)
      }
    }, function (e) {
      Vue.prototype.$Progress.fail()
      if (e) {
        if (e.name === undefined) {
          Vue.prototype.$Notify.error('Error', 'Ada kesalahan saat komunikasi ke web server...')
        } else {
          Vue.prototype.$Notify.error(e.name, e.message)
        }
      }
      if (typeof error === 'function') {
        error(e)
      }
    })
  },
  head: function (url, config, success, error) {
    Vue.prototype.$Progress.start()
    Vue.axios.head(url, config).then(function (e) {
      Vue.prototype.$Progress.finish()
      if (typeof success === 'function') {
        success(e.data)
      }
    }, function (e) {
      Vue.prototype.$Progress.fail()
      if (e) {
        if (e.name === undefined) {
          Vue.prototype.$Notify.error('Error', 'Ada kesalahan saat komunikasi ke web server...')
        } else {
          Vue.prototype.$Notify.error(e.name, e.message)
        }
      }
      if (typeof error === 'function') {
        error(e)
      }
    })
  },
  options: function (url, config, success, error) {
    Vue.prototype.$Progress.start()
    Vue.axios.options(url, config).then(function (e) {
      Vue.prototype.$Progress.finish()
      if (typeof success === 'function') {
        success(e.data)
      }
    }, function (e) {
      Vue.prototype.$Progress.fail()
      if (e) {
        if (e.name === undefined) {
          Vue.prototype.$Notify.error('Error', 'Ada kesalahan saat komunikasi ke web server...')
        } else {
          Vue.prototype.$Notify.error(e.name, e.message)
        }
      }
      if (typeof error === 'function') {
        error(e)
      }
    })
  },
  post: function (url, data, config, success, error) {
    Vue.prototype.$Progress.start()
    Vue.axios.post(url, data, config).then(function (e) {
      Vue.prototype.$Progress.finish()
      if (typeof success === 'function') {
        success(e.data)
      }
    }, function (e) {
      Vue.prototype.$Progress.fail()
      if (e) {
        if (e.name === undefined) {
          Vue.prototype.$Notify.error('Error', 'Ada kesalahan saat komunikasi ke web server...')
        } else {
          Vue.prototype.$Notify.error(e.name, e.message)
        }
      }
      if (typeof error === 'function') {
        error(e)
      }
    })
  },
  put: function (url, data, config, success, error) {
    Vue.prototype.$Progress.start()
    Vue.axios.put(url, data, config).then(function (e) {
      Vue.prototype.$Progress.finish()
      if (typeof success === 'function') {
        success(e.data)
      }
    }, function (e) {
      Vue.prototype.$Progress.fail()
      if (e) {
        if (e.name === undefined) {
          Vue.prototype.$Notify.error('Error', 'Ada kesalahan saat komunikasi ke web server...')
        } else {
          Vue.prototype.$Notify.error(e.name, e.message)
        }
      }
      if (typeof error === 'function') {
        error(e)
      }
    })
  },
  patch: function (url, data, config, success, error) {
    Vue.prototype.$Progress.start()
    Vue.axios.patch(url, data, config).then(function (e) {
      Vue.prototype.$Progress.finish()
      if (typeof success === 'function') {
        success(e.data)
      }
    }, function (e) {
      Vue.prototype.$Progress.fail()
      if (e) {
        if (e.name === undefined) {
          Vue.prototype.$Notify.error('Error', 'Ada kesalahan saat komunikasi ke web server...')
        } else {
          Vue.prototype.$Notify.error(e.name, e.message)
        }
      }
      if (typeof error === 'function') {
        error(e)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src_suopass/mixins/Send.js